<template>
  <SubLayout
      :pageTitle="title"
      :pageBreadcrumbs="breadcrumbs"
      :hasBack="false"
  >
    <template #subHeaderActions>
      <div class="d-flex align-items-center gap-2 gap-lg-3">
        <DateRangePicker id="society-offices-daterangepicker" @update:date="handleRangeDate1" />
      </div>
    </template>

    <template #layoutContent>
      <div class="accordion accordion-icon-toggle" :id="'kt_accordion_'+index" v-for="(society, index) in societiesOffices" :key="index">
          <div class="mb-5">
              <div class="accordion-header" data-bs-toggle="collapse" :data-bs-target="'#kt_accordion_'+ index +'_item_1'">
                  <div class="card shadow-sm mb-5 p-5 px-10">
                    <div class="row mt-5">
                      <div class="col-12 col-md-3 col-lg-3 mb-4 d-flex justify-align-center align-items-center">
                        <h3>{{society.name}}</h3>
                      </div>
                      <div class="col-12 col-md-2 col-lg-2 mb-4">
                        <div class="card p-3 h-100 bg-light-primary bg-light-primary" >
                          <div class="d-flex flex-stack">
                            <div class="symbol symbol-40px me-4">
                              <div class="symbol-label fs-2 py-10 px-8" :class="'bg-black'">
                                <span style="color: white;">{{society.officeHolidayTotalCount}}</span>
                              </div>
                            </div>
                            <div class="d-flex align-items-center flex-row-fluid flex-wrap">
                              <div class="flex-grow-1 me-2">
                                <a class="text-black fs-6 fw-bolder">
                                  {{$t('absences.title')}}
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-md-2 col-lg-2 mb-4">
                        <div class="card p-3 h-100 bg-light-primary bg-light-primary">
                          <div class="d-flex flex-stack">
                            <div class="symbol symbol-40px me-4">
                              <div class="symbol-label fs-2 py-10 px-8" :class="'bg-danger'">
                                <span style="color: white;">{{society.officeHolidayRejectedCount}}</span>
                              </div>
                            </div>
                            <div class="d-flex align-items-center flex-row-fluid flex-wrap">
                              <div class="flex-grow-1 me-2">
                                <a class="text-black fs-6 fw-bolder">
                                  {{$t('absences.REJECTED')}}
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-md-2 col-lg-2 mb-4">
                        <div class="card p-3 h-100 bg-light-primary bg-light-primary" >
                          <div class="d-flex flex-stack">
                            <div class="symbol symbol-40px me-4">
                              <div class="symbol-label fs-2 py-10 px-8" :class="'bg-success'">
                                <span style="color: white;">{{society.officeHolidayValidatedCount}}</span>
                              </div>
                            </div>
                            <div class="d-flex align-items-center flex-row-fluid flex-wrap">
                              <div class="flex-grow-1 me-2">
                                <a class="text-black fs-6 fw-bolder">
                                  {{$t('absences.VALIDATED')}}
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-md-2 col-lg-2 mb-4">
                        <div class="card p-3 h-100 bg-light-primary bg-light-primary" >
                          <div class="d-flex flex-stack">
                            <div class="symbol symbol-40px me-4">
                              <div class="symbol-label fs-2 py-10 px-8" :class="'bg-warning'">
                                <span style="color: white;">{{society.officeHolidayUnvalidatedCount}}</span>
                              </div>
                            </div>
                            <div class="d-flex align-items-center flex-row-fluid flex-wrap">
                              <div class="flex-grow-1 me-2">
                                <a class="text-black fs-6 fw-bolder">
                                  {{$t('absences.UNVALIDATED')}}
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-md-1 col-lg-1 mb-4 d-flex justify-content-center align-items-center" style="border-left: 2px solid #CCCFD3;">
                        <i class="fas fa-chevron-up" style="color: #303D4E !important; font-size: 20px;"/>
                      </div>
                    </div>
                  </div>
              </div>
              <div :id="'kt_accordion_'+ index +'_item_1'" class="fs-6 collapse show" :data-bs-parent="'#kt_accordion_'+index">
                <div class="row" v-if="society.offices?.length">
                  <div class="col-12 col-md-4 col-lg-4 mb-4 cursor-pointer" @click="openOffice(society.id, office.id)" v-for="(office, key) in society.offices" :key="key">
                    <div class="card shadow-sm mb-5 p-5">
                      <div class="row mt-5" style="border-bottom: 2px solid #CCCFD3;">
                        <div class="col-12 col-md-8 col-lg-8 mb-4 d-flex justify-align-center align-items-center">
                          <h3>{{office.name}}</h3>
                        </div>
                        <div class="col-12 col-md-4 col-lg-4 mb-4">
                          <div class="card p-3 h-100 bg-light-primary" >
                            <div class="d-flex flex-stack">
                              <div class="symbol symbol-40px me-4">
                                <div class="symbol-label fs-2 py-8 px-8 bg-white">
                                  <span class="text-black">{{office.officeHolidayTotalCount}}</span>
                                </div>
                              </div>
                              <div class="d-flex align-items-center flex-row-fluid flex-wrap">
                                <div class="flex-grow-1 me-2">
                                  <a class="text-black fs-6 fw-bolder">
                                    {{$t('absences.title')}}
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row mt-5">
                        <div class="col-12 col-md-4 col-lg-4 mb-4">
                          <div class="card p-3 h-100 bg-light-primary" >
                            <div class="d-flex flex-stack">
                              <div class="symbol symbol-40px me-4">
                                <div class="symbol-label fs-2 py-8 px-8 bg-white">
                                  <span class="text-danger">{{office.officeHolidayRejectedCount}}</span>
                                </div>
                              </div>
                              <div class="d-flex align-items-center flex-row-fluid flex-wrap">
                                <div class="flex-grow-1 me-2">
                                  <a class="text-black fs-6 fw-bolder">
                                    {{$t('absences.REJECTED')}}
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-12 col-md-4 col-lg-4 mb-4">
                          <div class="card p-3 h-100 bg-light-primary" >
                            <div class="d-flex flex-stack">
                              <div class="symbol symbol-40px me-4">
                                <div class="symbol-label fs-2 py-8 px-8 bg-white">
                                  <span class="text-success">{{office.officeHolidayValidatedCount}}</span>
                                </div>
                              </div>
                              <div class="d-flex align-items-center flex-row-fluid flex-wrap">
                                <div class="flex-grow-1 me-2">
                                  <a class="text-black fs-6 fw-bolder">
                                     {{$t('absences.VALIDATED')}}
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-12 col-md-4 col-lg-4 mb-4">
                          <div class="card p-3 h-100 bg-light-primary" >
                            <div class="d-flex flex-stack">
                              <div class="symbol symbol-40px me-4">
                                <div class="symbol-label fs-2 py-8 px-8 bg-white">
                                  <span class="text-warning">{{office.officeHolidayUnvalidatedCount}}</span>
                                </div>
                              </div>
                              <div class="d-flex align-items-center flex-row-fluid flex-wrap">
                                <div class="flex-grow-1 me-2">
                                  <a class="text-black fs-6 fw-bolder">
                                     {{$t('absences.UNVALIDATED')}}
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
          </div>
      </div>
    </template>
  </SubLayout>
</template>
<script setup> 
import {onMounted, ref, computed, watch, nextTick} from "vue";
import {useStore} from "vuex";
import {$formatLocalAmount} from "@/mixins/Helpers";
import SubLayout from "@/views/Layouts/partials/SubLayout.vue";
import Ls from "@/services/ls";
import {BASE_URL} from "@/services/api";
import {useLocales} from "@/composables/locales";
import DateRangePicker from "@/components/DateRangePicker.vue";
import Select2 from "@/components/Select2.vue";
import Button from "@/components/Button";
import i18n from "@/plugins/i18n";
import {useRouter} from 'vue-router';
import Input from "@/components/Input.vue";
import {formattedLocalAmount} from "@/mixins/Helpers";

const store = useStore()
const {locale} = useLocales()
const router = useRouter()

const title = ref("menu.rh.absences")
const breadcrumbs = ref([
  {
    name: 'absences.list',
    path: '/admin/rh/absences'
  }
])

const querySociety = ref({
  start_date: '',
  end_date: '',
  search: ""
})
const isLoading = ref(true)

const societiesOffices = computed(() => store.getters['absences/getSocietyHolidaysByOffice'])
const defaultCurrency = computed(() => store.getters['company/getCompanyCurrency'])
const currentCompanyId = computed(() => store.getters['offices/getSelectCompanyId'])


watch(() => [querySociety.value, currentCompanyId.value], (value) => {
  if(value){
    loadSocietyStat()
  }
},{deep:true})

function loadSocietyStat() {
  store.dispatch('absences/loadSocietyHolidaysByOffice', querySociety.value) 
}

function openOffice(society, id) {
  if(id){
    router.push({name: 'rh-absences-view', params: {society, id}})
  }
}

function handleRangeDate1 (range) {
  querySociety.value.start_date = range.start_date
  querySociety.value.end_date = range.end_date
}

onMounted(() => {
  if(querySociety.value.start_date && querySociety.value.end_date){
    loadSocietyStat()
  }
})
</script>

<style scoped>
  .grey-background {
    background-color: #f0f0f0;
  }
  .stat_class {
    background-color: var(--bs-light-primary);
    border-radius: 8px;
    padding: 5px;
    width: auto;
  }
</style>
